export const SHOP_THEMES = {
  premium: {
    key: "premium", dark: false,
    page: "bg-[#F6F4EF] text-[#181713]",
    nav: "bg-[#F6F4EF]/90 border-b border-[#E8E4D8]",
    card: "bg-white border border-[#EAE6DB]",
    hover: "hover:-translate-y-1 hover:shadow-[0_18px_45px_-15px_rgba(24,23,19,0.18)]",
    muted: "text-[#8B8578]",
    input: "w-full h-11 px-3 rounded-xl bg-white border border-[#E3DFD3] text-sm text-[#181713] focus:outline-none focus:border-[#181713]",
    btn: "rounded-full bg-[#181713] text-white hover:bg-black",
    ghost: "rounded-full border border-[#D9D4C6] text-[#181713] hover:bg-white",
    chip: "bg-[#EDE9DD] text-[#6E6857]",
    band: "bg-[#EDE9DD]/50",
    icon: "text-[#181713]",
    accentBox: "bg-[#EDE9DD] text-[#181713]",
    searchCard: "bg-white border border-[#EAE6DB] shadow-xl shadow-[#181713]/[0.05]",
    h1Style: { fontFamily: "Georgia, 'Times New Roman', serif", fontWeight: 500 },
  },
  stripe: {
    key: "stripe", dark: true,
    page: "bg-[#0A0F1E] text-white",
    nav: "bg-[#0A0F1E] border-b border-white/5",
    card: "bg-white/[0.04] border border-white/10",
    hover: "hover:-translate-y-1 hover:border-violet-500/40",
    muted: "text-slate-400",
    input: "w-full h-11 px-3 rounded-xl bg-white/5 border border-white/10 text-sm text-white focus:outline-none focus:border-violet-400",
    btn: "rounded-xl bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white hover:opacity-90",
    ghost: "rounded-xl border border-white/15 text-white hover:bg-white/5",
    chip: "bg-violet-500/15 text-violet-300",
    band: "bg-white/[0.03]",
    icon: "text-violet-400",
    accentBox: "bg-violet-500/15 text-violet-300",
    searchCard: "bg-white/[0.05] border border-white/10 backdrop-blur",
    h1Style: {},
    h1Extra: "bg-gradient-to-r from-white via-violet-100 to-violet-300 bg-clip-text text-transparent",
  },
  fun: {
    key: "fun", dark: false,
    page: "bg-[#FFF8F0] text-slate-900",
    nav: "bg-[#FFF8F0]/90 border-b border-orange-100",
    card: "bg-white border-2 border-orange-100",
    hover: "hover:-translate-y-1 hover:border-orange-300 hover:shadow-xl hover:shadow-orange-100",
    muted: "text-slate-500",
    input: "w-full h-11 px-3 rounded-2xl bg-white border-2 border-orange-100 text-sm text-slate-900 focus:outline-none focus:border-orange-400",
    btn: "rounded-full bg-gradient-to-r from-orange-500 to-pink-500 text-white hover:opacity-90",
    ghost: "rounded-full border-2 border-orange-200 text-orange-700 hover:bg-orange-50",
    chip: "bg-orange-100 text-orange-700",
    band: "bg-orange-50/70",
    icon: "text-orange-500",
    accentBox: "bg-orange-100 text-orange-600",
    searchCard: "bg-white border-2 border-orange-100 shadow-xl shadow-orange-100/60",
    h1Style: {},
  },
  pro: {
    key: "pro", dark: false,
    page: "bg-white text-slate-900",
    nav: "bg-white/95 border-b border-slate-200",
    card: "bg-white border border-slate-200 shadow-sm",
    hover: "hover:-translate-y-1 hover:shadow-lg hover:shadow-slate-200/80",
    muted: "text-slate-500",
    input: "w-full h-11 px-3 rounded-lg bg-white border border-slate-300 text-sm text-slate-900 focus:outline-none focus:border-blue-700",
    btn: "rounded-lg bg-blue-700 text-white hover:bg-blue-800",
    ghost: "rounded-lg border border-slate-300 text-slate-700 hover:bg-slate-50",
    chip: "bg-blue-50 text-blue-700",
    band: "bg-slate-50",
    icon: "text-blue-700",
    accentBox: "bg-blue-50 text-blue-700",
    searchCard: "bg-white border border-slate-200 shadow-lg shadow-slate-200/60",
    h1Style: {},
  },
};

export const normalizeTheme = (t) => ({ junago: "stripe", minimal: "premium" }[t] || t || "stripe");
export const getShopTheme = (t) => SHOP_THEMES[normalizeTheme(t)] || SHOP_THEMES.stripe;
